import { type ConfirmParam, ConfirmTypeEnum } from '../../types/Confirm';
import { formattedDate } from '../../utils/date';
import { toBig } from '../../utils/number';
import { HStack } from '../Core/HStack';
import { Stack } from '../Core/Stack';
import { InlineFormattedNumber } from '../FormattedNumber/InlineFormattedNumber';
import { Text } from '../Text';

export function ConfirmSynopsis({ confirm }: { confirm: ConfirmParam | undefined }) {
  if (confirm?.ConfirmType === ConfirmTypeEnum.RepoConfirm) {
    return (
      <Text>
        Rate{' '}
        <InlineFormattedNumber
          number={toBig(confirm.Confirm?.Rate)?.times(100)}
          currency="%"
          increment="0.01"
          showDashIfEmpty
        />{' '}
        <Text color="colorTextSubtle">/</Text>
        {' Haircut '}
        <InlineFormattedNumber
          number={toBig(confirm.Confirm?.HaircutRatio)?.times(100)}
          currency="%"
          increment="0.01"
          showDashIfEmpty
        />
      </Text>
    );
  }

  return null;
}

export function ConfirmTooltipContent({ confirm }: { confirm: ConfirmParam | undefined }) {
  if (confirm?.ConfirmType === ConfirmTypeEnum.RepoConfirm) {
    const details = confirm.Confirm;
    return (
      <Stack data-testid="confirm-tooltip-content" gap="spacing4" color="colorTextImportant" minWidth="240px">
        <Text fontWeight={500} color="colorTextDefault">
          Confirm Details
        </Text>
        {[
          { label: 'Rate', value: toBig(details?.Rate)?.times(100), currency: '%' },
          { label: 'Haircut', value: toBig(details?.HaircutRatio)?.times(100), currency: '%' },
          { label: 'Clean Price', value: details?.CleanPrice, currency: details?.CashCurrency },
          { label: 'Start Cash', value: details?.StartCash, currency: details?.CashCurrency },
          { label: 'End Cash', value: details?.EndCash, currency: details?.CashCurrency },
          { label: 'Repo Interest', value: details?.RepoInterest, currency: details?.CashCurrency },
        ].map(({ label, value, currency }) => (
          <HStack data-testid="confirm-tooltip-row" key={label} justifyContent="space-between" gap="spacing8">
            <Text color="colorTextDefault">{label}</Text>
            <InlineFormattedNumber
              number={value}
              currency={currency}
              increment={currency === '%' ? '0.01' : undefined}
              align="right"
            />
          </HStack>
        ))}
        {[
          ['Start Time', formattedDate(details?.StartTime) || '-'],
          ['End Time', formattedDate(details?.EndTime) || '-'],
          ['Collateral Asset', details?.CollateralAsset ?? '-'],
          ['Cash Currency', details?.CashCurrency ?? '-'],
        ].map(([label, value]) => (
          <HStack data-testid="confirm-tooltip-row" key={label} justifyContent="space-between" gap="spacing8">
            <Text color="colorTextDefault">{label}</Text>
            <Text>{value}</Text>
          </HStack>
        ))}
      </Stack>
    );
  }

  return null;
}
